const svgDataUriRegExp: RegExp = /^data\:image\/svg\+xml/;

export function encodeSvg(svg: string): string {
    return svgDataUriRegExp.test(svg) ? svg : `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
